import { Stack } from '@optimus-web/core';
import { DateTimeIntervalFilterFields, FilterValueKey } from '../../../common';

export const ResourceBlocksFilterFields = () => (
    <Stack vertical spacing="300">
        <DateTimeIntervalFilterFields
            startDateFieldName={FilterValueKey.startDate}
            endDateFieldName={FilterValueKey.endDate}
        />
    </Stack>
);
